package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.frontend.collections.EditCollectionNameDialog
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.State
import horcrux.frontend.common.ViewRefreshState
import horcrux.frontend.common.views.collections.CollectionMetadataByID
import horcrux.frontend.common.views.collections.CollectionNavigatorState
import horcrux.frontend.common.views.collections.importdocuments.CreateCollectionAndImportDocumentDialog
import react.FC
import react.Props

external interface CollectionDialogsProps : Props {
    var collectionMetadataByIDState: State<CollectionMetadataByID>
    var collectionNavigatorState: CollectionNavigatorState
    var currentCollectionMetadataMaybeState: State<CollectionMetadata?>
    var documentMetadataList: List<DocumentMetadata>
    var globalAppState: GlobalAppState
    var viewRefreshState: ViewRefreshState
}

val CollectionDialogs = FC<CollectionDialogsProps> { props ->
    val collectionMetadataByID = props.collectionMetadataByIDState.get()
    CreateCollectionDialog {
        this.showDialogState = props.collectionNavigatorState.showCreateCollectionDialogState
        this.collectionMetadataByID = collectionMetadataByID
        this.updateCollectionMetadata = {
            props.collectionMetadataByIDState.set(collectionMetadataByID.add(it))
            props.currentCollectionMetadataMaybeState.set(it)
        }
        this.closeDialog = { props.collectionNavigatorState.closeDialogs() }
        this.globalAppState = props.globalAppState
    }

    CreateCollectionAndImportDocumentDialog {
        this.showDialogState = props.collectionNavigatorState.showImportDocumentDialogState
        this.currentCollectionMetadataMaybeState = props.currentCollectionMetadataMaybeState
        this.collectionMetadataByID = collectionMetadataByID
        this.documentMetadataList = props.documentMetadataList
        this.collectionNavigatorState = props.collectionNavigatorState
        this.updateCollectionMetadata = {
            props.collectionMetadataByIDState.set(collectionMetadataByID.add(it))
            props.currentCollectionMetadataMaybeState.set(it)
        }
        this.closeDialog = { props.collectionNavigatorState.closeDialogs() }
        this.globalAppState = props.globalAppState
        this.viewRefreshState = props.viewRefreshState
    }

    ManageChatPagesDialog {
        this.globalAppState = props.globalAppState
    }

    props.currentCollectionMetadataMaybeState.get()?.let { currentCollectionMetadata ->
        CollectionDetailsDialog {
            this.currentCollectionMetadata = currentCollectionMetadata
            this.collectionNavigatorState = props.collectionNavigatorState
        }
        EditCollectionNameDialog {
            this.showDialog = props.collectionNavigatorState.showEditNameDialogState.get()
            this.collectionMetadataByID = collectionMetadataByID
            this.collectionMetadata = currentCollectionMetadata
            this.updateCollectionMetadataByID =
                { props.collectionMetadataByIDState.set(collectionMetadataByID.replace(it)) }
            this.closeDialog = { props.collectionNavigatorState.closeDialogs() }
            this.globalAppState = props.globalAppState
        }

        DeleteCollectionDialog {
            this.currentCollectionMetadata = currentCollectionMetadata
            this.globalAppState = props.globalAppState
        }
    }

    props
        .globalAppState
        .currentChatPageMetadataMaybeState
        .get()
        ?.let { currentChatPageMetadata ->
            ChatPageDetailsDialog {
                this.currentChatPageMetadata = currentChatPageMetadata
                this.globalAppState = props.globalAppState
            }
            DeleteChatPageDialog {
                this.currentChatPageMetadata = currentChatPageMetadata
                this.globalAppState = props.globalAppState
            }
        }
}
